import { Pressable } from "react-native"
import MCATextField  from "./MCATextField";
import DocumentPicker  from "react-native-document-picker";
import { useState } from "react";
import React from 'react'

const FilePicker = (props:any) => {
    let data = props.data

    const [fileName, setFileName] = useState("")

    async function pickFile () {
        const pickedFile = await DocumentPicker.pickSingle({
            type:[DocumentPicker.types.allFiles]
        });
        console.log('pickedFile');
        console.log(pickedFile);
        console.log(pickedFile.type);
        if (pickedFile != null) {
            setFileName(pickedFile.name ?? "")
            props.onFilePicked(data["name"], pickedFile)
        }
    //  pickedFile.type ==
        // DocumentPicker.getDocumentAsync()
        //     .then((docResult:any) => {

               
        //     })
    }
  return (
    <Pressable onPress={pickFile}>
            <MCATextField valueString={fileName} data={data} editable={false} />
        </Pressable>
  )
}

export default FilePicker

